import { createRoot } from "react-dom/client";
import App from "./App.tsx";
// Self-hosted Inter (no Google Fonts CDN) so the app loads on restrictive
// networks and ad/tracker-blocking filters, and serves from a single origin.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "@fontsource/inter/900.css";
import "./index.css";
import { initErrorReporting } from "@/lib/utils/analytics";

// Capture errors that escape React's boundary (global errors + promise rejections).
initErrorReporting();

createRoot(document.getElementById("root")!).render(<App />);

// Service worker intentionally NOT registered. A cached worker repeatedly served
// a stale app shell during the domain/hosting migration and could not self-heal
// under split DNS. We removed it. As defensive cleanup, proactively unregister
// any worker a returning visitor still has installed and clear its caches; the
// kill-switch in public/sw.js does the same for clients where the app never
// boots. Together these guarantee no stale worker survives.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations?.()
    .then((regs) => regs.forEach((r) => r.unregister()))
    .catch(() => { /* ignore */ });
}
if (typeof caches !== "undefined") {
  caches.keys()
    .then((keys) => keys.forEach((k) => caches.delete(k)))
    .catch(() => { /* ignore */ });
}
